module.exports = __webpack_public_path__ + "static/img/pexels-alena-koval-886521.e2e2db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pexels-alena-koval-886521.png
// module id = Q/EV
// module chunks = 0